<template>
  <div v-click-outside="closeSideMenu">
    <q-header
      elevated
      class="header-container"
      :class="getEnv === 'prod' ? 'prod-env' : 'stage-env'"
    >
      <q-toolbar>
        <q-btn v-if="user" dense flat round @click="toggleLeftDrawer">
          <font-awesome-icon :icon="handlerMenuIcon()" size="xl" />
        </q-btn>

        <img
          alt="Vue logo"
          src="../../assets/aarp-logo.svg"
          class="q-ml-md"
          onclick="window.location='/';"
        />

        <span class="env-text" v-if="user">
          {{ getEnv === "prod" ? "[PRODUCTION]" : "[STAGE]" }}
        </span>
        <div class="env-content" v-if="user && isProdEnv">
          <SelectEnv />
        </div>
        <div class="login-content">
          <HeaderLogin />
        </div>
      </q-toolbar>
    </q-header>
    <SideMenu />
  </div>
</template>

<script>
import SideMenu from "@/components/sidemenu/SideMenu.vue";
import SelectEnv from "@/components/env/SelectEnv.vue";
import { mapActions, mapGetters } from "vuex";
import HeaderLogin from "@/components/header/HeaderLogin";

export default {
  name: "HeaderBar",
  data() {
    return {
      isProdEnv: false,
    };
  },
  components: {
    SideMenu,
    SelectEnv,
    HeaderLogin,
  },
  computed: {
    ...mapGetters({ getIsOpen: "sidebar/getIsOpen" }),
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
    ...mapGetters({ user: "auth/getUser" }),
  },

  async created() {
    this.isProdEnv = process.env.NODE_ENV === "production";
  },

  methods: {
    ...mapActions({
      setSideMenuOpen: "sidebar/setSideMenuOpen",
    }),

    // set Open/Close Side menu as a State
    toggleLeftDrawer() {
      this.setSideMenuOpen(!this.getIsOpen);
    },

    handlerMenuIcon() {
      if (this.getIsOpen) {
        return "times";
      } else {
        return "bars";
      }
    },

    closeSideMenu() {
      if (this.getIsOpen) {
        this.setSideMenuOpen(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  cursor: pointer;
}

.header-container {
  z-index: 7000;
}

.q-btn {
  :deep(.q-ripple) {
    display: none;
  }
}

.env-content {
  position: relative;
  z-index: 7001;
}

.login-content {
  z-index: 7001;
  position: absolute;
  right: 5%;
}

.env-text {
  font-size: 16px;
  letter-spacing: 1px;
  margin-top: auto;
}

.prod-env {
  background-color: $primary;
}
.stage-env {
  background-color: $secondary;
  color: black;
}
</style>
